import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Subscription, take } from 'rxjs';
import { Observable } from 'tinymce';

@Injectable({
  providedIn: 'root',
})
export class SlackLoggerService {
  constructor(private http: HttpClient) {}

  logToSlack(payload: any): any {
    return this.http.post(`${environment.host}/log-to-slack`, {
      payload: JSON.stringify({
        ...payload,
        timestamp: new Date().toISOString(),
      }),
    });
  }
}
